import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '@/_modules/authentication/auth.service';
import { UserStore } from '../_modules/shared/_stores/user.store';

export const CanActivateDashboard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const userStore = inject(UserStore);
  const router = inject(Router);

  return auth.canOpenDashboard().pipe(
    map((isAuth) => {
      if (isAuth) {
        userStore.setAuthenticated(true);
        userStore.setDashboard(isAuth);
        return true;
      }
      return router.createUrlTree([auth.isAuthenticated() ? '/login/terms' : '/login']);
      //return router.createUrlTree(['/login']);
    }),
  );
};
